var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "ns-expressive-link",
      class: [_vm.animationState, { invert: _vm.invert }],
      style: _vm.dynamicStyle,
      attrs: { href: _vm.href, target: _vm.target },
      on: {
        mouseover: _vm.addAnimateIn,
        mouseout: _vm.addAnimateOut,
        click: _vm.handleClick
      }
    },
    [
      _c("span", { staticClass: "slot" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("span", { staticClass: "before" }),
      _vm._v(" "),
      _c("span", { staticClass: "after" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }